@use '@fpsm/cxy-scss' as cxy;

.productCard {
  @include cxy.grid;
  grid-template-areas: 'title' 'image' 'content';
  column-gap: var(--cxy-spacing-lg);
  row-gap: var(--cxy-spacing-3);
  padding: var(--cxy-spacing-3);
}
.productCard + .productCard {
  margin-block-start: var(--cxy-spacing-lg);
}
.productCard h2 {
  color: var(--cxy-color-brand);
  font-size: var(--cxy-fontSize-xxl);
  font-weight: var(--cxy-fontWeight-bold);
  line-height: 36px;
}
@media (min-width: 801px) {
  .productCard h2 {
    font-size: var(--cxy-fontSize-xxxl);
    line-height: 44px;
  }
}
@media (min-width: 801px) {
  .productCard {
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 2fr;
    padding: var(--cxy-spacing-lg) 72px;
  }
  .productCard.image--leading {
    grid-template-columns: 1fr 2fr;
    grid-template-areas: 'image  title' 'image  content';
  }
  .productCard.image--trailing {
    grid-template-areas: '  title image' '  content image';
    grid-template-columns: 2fr 1fr;
  }
}
[data-fpsm-theme='whoscored'] .productCard {
  background: var(--cxy-color-surface-success-default-subtle-hover);
}

.imageContainer {
  grid-area: image;
  margin: auto;
  border-radius: var(--cxy-border-radius-m);
  background: var(--cxy-color-surface-success-default-subtle-hover);
}
[data-fpsm-theme='whoscored'] .imageContainer {
  padding: var(--cxy-spacing-xxsm);
  background: var(--cxy-color-container-strong);
}
.imageContainer,
.imageContainer img {
  width: 100%;
  min-width: 300px;
}

.textContainer {
  grid-area: content;
  @include cxy.stack(var(--cxy-spacing-xxsm));
}
.textContainer p {
  font-size: var(--cxy-fontSize-m);
  font-weight: var(--cxy-fontWeight-medium);
  line-height: var(--cxy-lineHeight-l);
  margin-block: var(--cxy-spacing-xxsm);
}
.textContainer svg {
  color: var(--cxy-color-text-default-placeholder);
}

.title {
  grid-area: title;
  padding-block: var(--cxy-spacing-xxxsm);
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  .productCard {
    background: var(--cxy-color-surface-page);
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.3);
    row-gap: var(--cxy-spacing-3);
    padding: var(--cxy-spacing-3);
  }
  .textContainer {
    gap: var(--cxy-spacing-sm);

    button {
      margin-top: auto;
    }
    p {
      margin-block: unset;
    }
  }

  @media (min-width: 801px) {
    .productCard {
      grid-template-rows: auto 1fr;
      grid-template-columns: 1fr 2fr;
      padding: var(--cxy-spacing-lg) 72px;

      &.image--leading {
        grid-template-columns: 1fr 2fr;
        grid-template-areas: 'image  title' 'image  content';
      }
      &.image--trailing {
        grid-template-areas: '  title image' '  content image';
        grid-template-columns: 2fr 1fr;
      }
    }
    .imageContainer {
      align-self: start;
      margin: 0;
    }
    .textContainer {
      p {
        font-size: var(--cxy-fontSize-xl);
      }
    }
  }
}
